export default __webpack_public_path__ + "static/media/favorites-power.394dbc55.png";